module.exports = __webpack_public_path__ + "static/media/Icon_2D Animation_Grey.237b7627.svg";